import api from '@/services/api'

export const deletePdfs = async (imageId: string) => {
  await api.delete(`/admin/customers/reports/steps/pdfs/${imageId}`)
}
